import React from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import Footer from './footer'
import './navbar-interactive.css'

const NavbarInteractive = (props) => {
  return (
    <nav
      data-role="Header"
      className={`navbar-interactive-navbar ${props.rootClassName} `}
    >
      <header
        data-thq="thq-navbar"
        className="navbar-interactive-navbar-interactive"
      >
        <div className="navbar-interactive-container1">
          <Link to="/" className="navbar-interactive-navlink1">
            <img
              alt={props.imageAlt}
              src={props.imageSrc}
              className="navbar-interactive-image1"
            />
          </Link>
          <div
            data-thq="thq-navbar-nav"
            data-role="Nav"
            className="navbar-interactive-desktop-menu"
          >
            <nav
              data-thq="thq-navbar-nav-links"
              data-role="Nav"
              className="navbar-interactive-nav1"
            >
              <Link to="/" className="navbar-interactive-boek1">
                BOEK
              </Link>
              <Link to="/over-marjan" className="navbar-interactive-over1">
                OVER MARJAN
              </Link>
              <Link to="/fotos-bij-boek" className="navbar-interactive-fotos1">
                FOTO&apos;S BIJ BOEK
              </Link>
              <Link to="/agenda-en-media" className="navbar-interactive-agenda1">
                AGENDA EN MEDIA
              </Link>
              <Link to="/blog" className="navbar-interactive-blog1">
                BLOG
              </Link>
              <Link to="/contact" className="navbar-interactive-contact1">
                CONTACT
              </Link>
            </nav>
          </div>
          <div
            data-thq="thq-burger-menu"
            className="navbar-interactive-burger-menu"
          >
            <svg viewBox="0 0 1024 1024" className="navbar-interactive-icon1">
              <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
            </svg>
          </div>
          <div
            data-thq="thq-mobile-menu"
            className="navbar-interactive-mobile-menu"
          >
            <div
              data-thq="thq-mobile-menu-nav"
              data-role="Nav"
              className="navbar-interactive-nav2"
            >
              <div className="navbar-interactive-container2">
                <div
                  data-thq="thq-close-menu"
                  className="navbar-interactive-menu-close"
                >
                  <Link to="/" className="navbar-interactive-navlink2">
                    <img
                      alt={props.imageAlt1}
                      src={props.imageSrc1}
                      className="navbar-interactive-image2"
                    />
                  </Link>
                  <svg
                    viewBox="0 0 1024 1024"
                    className="navbar-interactive-icon3"
                  >
                    <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                  </svg>
                </div>
              </div>
              <nav
                data-thq="thq-mobile-menu-nav-links"
                data-role="Nav"
                className="navbar-interactive-nav3"
              >
                <Link to="/" className="navbar-interactive-boek2">
                  BOEK
                </Link>
                <Link to="/over-marjan" className="navbar-interactive-over2">
                  OVER MARJAN
                </Link>
                <Link
                  to="/fotos-bij-boek"
                  className="navbar-interactive-fotos2"
                >
                  FOTO&apos;S BIJ BOEK
                </Link>
                <Link
                  to="/agenda-en-media"
                  className="navbar-interactive-agenda2"
                >
                  AGENDA EN MEDIA
                </Link>
                <Link to="/blog" className="navbar-interactive-blog2">
                  BLOG
                </Link>
                <Link to="/contact" className="navbar-interactive-contact2">
                  CONTACT
                </Link>
              </nav>
            </div>
            <div className="navbar-interactive-icon-group">
              <Footer rootClassName="footerroot-class-name23"></Footer>
            </div>
          </div>
        </div>
      </header>
    </nav>
  )
}

NavbarInteractive.defaultProps = {
  imageSrc1: '/mijn%20naam-200h.png',
  imageAlt: 'image',
  imageAlt1: 'image',
  imageSrc: '/mijn%20naam-200h.png',
  rootClassName: '',
}

NavbarInteractive.propTypes = {
  imageSrc1: PropTypes.string,
  imageAlt: PropTypes.string,
  imageAlt1: PropTypes.string,
  imageSrc: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default NavbarInteractive
